import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { BeakerIcon, UsersIcon, TargetIcon, BuildingIcon, ArrowRight } from 'lucide-react';
const AboutPage = () => {
  return <div className="min-h-screen bg-white" data-id="element-176" data-mp="53h1uaes9iwz">
      <Navbar data-id="element-177" data-mp="7igkvor4h0s" />
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-teal-900 to-teal-800 text-white" data-id="element-178" data-mp="4mmxjjxsei5">
        <div className="absolute inset-0 overflow-hidden" data-id="element-179" data-mp="3rebiy2va6m6w">
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')] bg-cover bg-center opacity-20" data-id="element-180" data-mp="3mdnthlmpades"></div>
        </div>
        <div className="relative container mx-auto px-4 py-24 max-w-7xl" data-id="element-181" data-mp="3deag4hvgh4os">
          <div className="max-w-3xl" data-id="element-182" data-mp="1glifq4frw2mz">
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-183" data-mp="1gkguj751lzrj">
              About CalBiome
            </h1>
            <p className="text-xl mb-8 text-teal-100" data-id="element-184" data-mp="1bmnm07g9oto3">
              Transforming microbiome research into practical solutions for
              better health
            </p>
          </div>
        </div>
      </div>
      {/* Main Content */}
      <div className="container mx-auto px-4 py-16 max-w-7xl" data-id="element-185" data-mp="25vswip9qw029">
        {/* Our Story Section */}
        <div className="mb-16" data-id="element-186" data-mp="2auceyfp4qtpv">
          <h2 className="text-3xl font-bold text-gray-800 mb-6" data-id="element-187" data-mp="2avf70qy6v27d">Our Story</h2>
          <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8" data-id="element-188" data-mp="2yjyex5dbtcyx">
            <p className="text-lg text-gray-700 mb-6" data-id="element-189" data-mp="32ljz7bs6wtj5">
              CalBiome is the applied research and product development arm of
              the California Institute for Microbiome Research (CalMiR). While
              CalMiR focuses on academic-grade discovery and clinical
              validation, CalBiome transforms those findings into trusted
              supplements, protocols, and consumer-ready solutions.
            </p>
            <p className="text-lg text-gray-700" data-id="element-190" data-mp="3makk8ovy4j58">
              Founded on the principle that cutting-edge microbiome science
              should be accessible to everyone, we bridge the gap between
              laboratory discoveries and practical health solutions. Our team of
              scientists, healthcare professionals, and product developers work
              collaboratively to ensure that every CalBiome product meets the
              highest standards of efficacy and safety.
            </p>
          </div>
        </div>
        {/* What Sets Us Apart */}
        <div className="mb-16" data-id="element-191" data-mp="38fx6pnbojb7g">
          <h2 className="text-3xl font-bold text-gray-800 mb-6" data-id="element-192" data-mp="38em77zp9opm5">
            What Sets Us Apart
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-193" data-mp="33hdnvvsdufjb">
            <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8" data-id="element-194" data-mp="2yj2a59yyvkvt">
              <div className="flex items-center mb-4" data-id="element-195" data-mp="2tj66jbu6lvgs">
                <BeakerIcon size={24} className="text-teal-600 mr-3" data-id="element-196" data-mp="2tkr1v3oblifp" />
                <h3 className="text-xl font-semibold text-gray-800" data-id="element-197" data-mp="2phunxq9q6ai3">
                  Science-First Approach
                </h3>
              </div>
              <p className="text-gray-700" data-id="element-198" data-mp="190lwltfthu8c">
                Unlike many wellness companies, we start with rigorous science.
                Every product and protocol is developed based on peer-reviewed
                research and clinical validation from CalMiR.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8" data-id="element-199" data-mp="lbkv6q5ejjck">
              <div className="flex items-center mb-4" data-id="element-200" data-mp="qadzpt2po00l">
                <TargetIcon size={24} className="text-teal-600 mr-3" data-id="element-201" data-mp="qaxfb34w2cbg" />
                <h3 className="text-xl font-semibold text-gray-800" data-id="element-202" data-mp="v97ahdqm5cx2">
                  Ukweli Certified™
                </h3>
              </div>
              <p className="text-gray-700" data-id="element-203" data-mp="102a8by2fb8j2">
                All CalBiome products undergo independent certification through
                the Ukweli Institute, ensuring purity, potency, and adherence to
                the highest quality standards.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8" data-id="element-204" data-mp="299los90whizu">
              <div className="flex items-center mb-4" data-id="element-205" data-mp="258s19grde67h">
                <BuildingIcon size={24} className="text-teal-600 mr-3" data-id="element-206" data-mp="2iylojun88if3" />
                <h3 className="text-xl font-semibold text-gray-800" data-id="element-207" data-mp="2j0yask00pexy">
                  Institutional Backing
                </h3>
              </div>
              <p className="text-gray-700" data-id="element-208" data-mp="2sw9rv8ywey8v">
                As part of the CalMiR ecosystem, we have access to
                state-of-the-art research facilities, a network of scientific
                experts, and the latest discoveries in microbiome science.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8" data-id="element-209" data-mp="2wyeidyu1vera">
              <div className="flex items-center mb-4" data-id="element-210" data-mp="17j6twxihq2n5">
                <UsersIcon size={24} className="text-teal-600 mr-3" data-id="element-211" data-mp="17lsyqpdzy41o" />
                <h3 className="text-xl font-semibold text-gray-800" data-id="element-212" data-mp="12lx2xdfgdix7">
                  Consumer-Focused
                </h3>
              </div>
              <p className="text-gray-700" data-id="element-213" data-mp="3j725tdh2uj22">
                We translate complex scientific findings into practical,
                easy-to-use products and protocols that fit seamlessly into
                everyday life, making advanced microbiome health accessible to
                all.
              </p>
            </div>
          </div>
        </div>
        {/* Our Team */}
        <div className="mb-16" data-id="element-214" data-mp="2vjk9d4mvawsr">
          <h2 className="text-3xl font-bold text-gray-800 mb-6" data-id="element-215" data-mp="30gardxi8g2gt">Our Team</h2>
          <p className="text-lg text-gray-700 mb-8" data-id="element-216" data-mp="30e7qgifjkoxb">
            CalBiome brings together experts from microbiology, nutrition,
            medicine, and product development to create innovative solutions for
            microbiome health.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-217" data-mp="kqr7b9j3ijaf">
            {/* Azn Alahah */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow" data-id="element-218" data-mp="opzws273rv06">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ukGcG9zx2afckVSimno9Ts/Generated_Image_September_17%2C_2025_-_8_14PM~2.png" alt="Azn Alahah" className="h-64 w-full object-cover" data-id="element-219" data-mp="1xlvheubpby1h" />
              <div className="p-6" data-id="element-220" data-mp="1jpia2e0vtd0q">
                <h3 className="text-xl font-semibold text-gray-800 mb-1" data-id="element-221" data-mp="1jq9s0m1k3c8j">
                  Azn Alahah
                </h3>
                <p className="text-teal-600 mb-4" data-id="element-222" data-mp="2cd4efohxolon">
                  Founder & Executive Director
                </p>
                <p className="text-gray-700" data-id="element-223" data-mp="27lcl567e81ut">
                  Azn Alahah is a microbiome researcher with over 5 years of
                  experience in gut health and therapeutic development.
                  Previously led research teams at leading pharmaceutical
                  companies focusing on microbiome-targeted therapies.
                </p>
              </div>
            </div>
            {/* Dr. Michael Patel */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow" data-id="element-224" data-mp="32ofy8bchn4fi">
              <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Dr. Michael Patel" className="h-64 w-full object-cover" data-id="element-225" data-mp="3cl2eemtvd7b7" />
              <div className="p-6" data-id="element-226" data-mp="3lkxrwyawdeee">
                <h3 className="text-xl font-semibold text-gray-800 mb-1" data-id="element-227" data-mp="3ljwguttvsrwo">
                  Dr. Michael Patel
                </h3>
                <p className="text-teal-600 mb-4" data-id="element-228" data-mp="3vb0p7ap1xeij">Chief Scientific Officer</p>
                <p className="text-gray-700" data-id="element-229" data-mp="45978ylfh86t">
                  Leads scientific vision and product development, specializing
                  in biofilms and their impact on gut health. Pioneer in biofilm
                  disruption strategies.
                </p>
                <Link to="/team/michael-patel" className="inline-flex items-center text-teal-600 hover:text-teal-800 mt-3 text-sm" data-id="element-230" data-mp="d673uvtjedfd">
                  View profile <ArrowRight size={14} className="ml-1" data-id="element-231" data-mp="thjckrfl23qi" />
                </Link>
              </div>
            </div>
            {/* Dr. Sarah Chen */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow" data-id="element-232" data-mp="13fpbd063etr5">
              <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Dr. Sarah Chen" className="h-64 w-full object-cover" data-id="element-233" data-mp="fqw9kn2shrom" />
              <div className="p-6" data-id="element-234" data-mp="koxu7cfv5z27">
                <h3 className="text-xl font-semibold text-gray-800 mb-1" data-id="element-235" data-mp="kopivoze31t4">
                  Dr. Sarah Chen
                </h3>
                <p className="text-teal-600 mb-4" data-id="element-236" data-mp="3t36iw9f9m5p3">Research Director</p>
                <p className="text-gray-700" data-id="element-237" data-mp="3o5ogl1vr6oq2">
                  Leads research initiatives focused on the microbiome-gut-brain
                  connection. Published over 30 peer-reviewed papers on
                  microbial neurotransmitter production.
                </p>
                <Link to="/team/sarah-chen" className="inline-flex items-center text-teal-600 hover:text-teal-800 mt-3 text-sm" data-id="element-238" data-mp="1tqr3zw3v8zaq">
                  View profile <ArrowRight size={14} className="ml-1" data-id="element-239" data-mp="2medihzemtocd" />
                </Link>
              </div>
            </div>
          </div>
        </div>
        {/* Our Vision */}
        <div data-id="element-240" data-mp="2ddytaoyjrp3l">
          <h2 className="text-3xl font-bold text-gray-800 mb-6" data-id="element-241" data-mp="2dehzx9iqyr2b">Our Vision</h2>
          <div className="bg-gradient-to-r from-teal-50 to-teal-100 rounded-lg p-8 border border-teal-100" data-id="element-242" data-mp="2hfk29z7ynj8i">
            <p className="text-xl text-gray-700 mb-6" data-id="element-243" data-mp="11z1r0ddcr3ea">
              CalBiome envisions a future where microbiome science transforms
              preventative healthcare and wellness, making personalized,
              science-backed solutions accessible to everyone.
            </p>
            <p className="text-lg text-gray-700" data-id="element-244" data-mp="1qpwymitdksk8">
              We're building a portfolio of next-generation microbiome therapies
              — from probiotics and nutraceuticals to personalized reset
              protocols. Our goal is to become the most trusted science-first
              wellness brand, shaping a new era of microbiome health.
            </p>
          </div>
        </div>
      </div>
      <Footer data-id="element-245" data-mp="1cw5xnytpmh04" />
    </div>;
};
export default AboutPage;